// import { useIdleTimer } from 'react-idle-timer'
// import { useNavigate } from 'react-router-dom'
// import { Fetch } from '../../shared/Fetch'


// const IdleLogout = () => {
//   const navigate = useNavigate()

//   const onIdle = async () => {
//     const auth = JSON.parse(sessionStorage.getItem("auth") || "{}")
//     if (auth?.loginHistoryId) {
//       await Fetch("User/logout", "POST", {loginHistoryId: auth.loginHistoryId}, null, null)
//     }
//     sessionStorage.clear()
//     navigate("/login")
//   }

//   useIdleTimer({
//     timeout: 1000 * 60 * 2, 
//     onIdle: onIdle,
//     debounce: 500
//   })

//   return null
// }

// export default IdleLogout
import { useIdleTimer } from 'react-idle-timer'
import { useNavigate } from 'react-router-dom'
import { Fetch } from '../../shared/Fetch'
import { Toast } from 'primereact/toast'
import { useRef } from 'react'

const IdleLogout = () => {
  const navigate = useNavigate()
  const toast = useRef<any>(null)

  const onPrompt = () => {
    toast.current?.show({
      severity: "warn",
      summary: "Session Expiring",
      detail: "You will be logged out in 30 seconds due to inactivity.",
      life: 30000
    })
  }

  const onIdle = async () => {
    const auth = JSON.parse(sessionStorage.getItem("auth") || "{}")

    if (auth?.loginHistoryId) {
      await Fetch("User/logout", "POST", { loginHistoryId: auth.loginHistoryId }, null, null)
    }

    sessionStorage.clear()
    navigate("/login")
  }

  const { reset } = useIdleTimer({
    timeout: 1000 * 60 * 20,      // 5 minutes
    promptBeforeIdle: 30000,     // 30 sec before logout
    onPrompt,
    onIdle,
    debounce: 500,
    onAction: () => {
      toast.current?.clear()
      reset()
    }
  })

  return <Toast ref={toast} position="top-right" />
}

export default IdleLogout